/** Max span of a normal matchday slate used to drop early/late outliers. */
const ROUND_KICKOFF_CLUSTER_MAX_SPAN_MS = 14 * 24 * 60 * 60 * 1000;

/**
 * Largest set of kickoffs that fit in {@link ROUND_KICKOFF_CLUSTER_MAX_SPAN_MS}.
 * Ties prefer the later cluster so early-played outliers lose to the upcoming slate.
 *
 * @param {number[]} kickoffsMs
 * @param {number} [maxSpanMs]
 * @returns {number[]} sorted kickoffs in the main cluster (or all, if empty input)
 */
function filterKickoffsInMainCluster(kickoffsMs, maxSpanMs = ROUND_KICKOFF_CLUSTER_MAX_SPAN_MS) {
  const sorted = [...kickoffsMs]
    .map((k) => Number(k))
    .filter((k) => Number.isFinite(k))
    .sort((a, b) => a - b);
  if (sorted.length <= 1) return sorted;

  let bestStart = 0;
  let bestEnd = 1;
  let j = 0;
  for (let i = 0; i < sorted.length; i++) {
    while (j < sorted.length && sorted[j] - sorted[i] <= maxSpanMs) j += 1;
    const len = j - i;
    const bestLen = bestEnd - bestStart;
    if (len > bestLen || (len === bestLen && sorted[i] > sorted[bestStart])) {
      bestStart = i;
      bestEnd = j;
    }
  }
  return sorted.slice(bestStart, bestEnd);
}

/**
 * @param {number} kickoffMs
 * @param {number[]} allKickoffsMs
 * @param {number} [maxSpanMs]
 */
function isKickoffInMainCluster(kickoffMs, allKickoffsMs, maxSpanMs = ROUND_KICKOFF_CLUSTER_MAX_SPAN_MS) {
  const k = Number(kickoffMs);
  if (!Number.isFinite(k)) return false;
  const cluster = filterKickoffsInMainCluster(allKickoffsMs, maxSpanMs);
  return cluster.includes(k);
}

module.exports = {
  ROUND_KICKOFF_CLUSTER_MAX_SPAN_MS,
  filterKickoffsInMainCluster,
  isKickoffInMainCluster
};
